module.exports = __webpack_public_path__ + "static/garnishings04-82ec4e3c569302591b0290c748e0ddef.jpg";